import request from '@/utils/request'

// 配置

let SettingApi = {
    /*保存设置*/
    saveSetting(data, errorback) {
        return request._post('/shop/study.setting/index', data, errorback);
    },
    /*获取设置*/
    getSetting(data, errorback) {
        return request._post('/shop/study.setting/index', data, errorback);
    },
    /*设置-基础设置*/
    basic(data, errorback) {
        return request._post('/shop/study.setting/basic', data, errorback);
    },
    /*设置-其它设置*/
    other(data, errorback) {
        return request._post('/shop/study.setting/other', data, errorback);
    },
    /*设置-首页设置*/
    home(data, errorback) {
        return request._post('/shop/study.setting/home', data, errorback);
    },
}

export default SettingApi;



// WEBPACK FOOTER //
// ./src/api/study/setting.js